import { render, staticRenderFns } from "./AIAvatarSource.vue?vue&type=template&id=046c447f&scoped=true"
import script from "./AIAvatarSource.vue?vue&type=script&lang=ts"
export * from "./AIAvatarSource.vue?vue&type=script&lang=ts"
import style0 from "./AIAvatarSource.vue?vue&type=style&index=0&id=046c447f&prod&lang=scss"
import style1 from "./AIAvatarSource.vue?vue&type=style&index=1&id=046c447f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046c447f",
  null
  
)

export default component.exports